import { FsManufacturer, mapFsManufacturer } from './../Manufacturer';
import { FSAppliance, mapFSAppliance } from "../Appliance";
import { FSBrand, mapFSBrand } from "../Brand";
import { FSColor, mapFSColor } from "../Color";
import { FSFileList, mapFSFileLists } from "../FileList";
import { FSDataOrder, mapFSDataOrder } from "../Order";
import { FSType, mapFSType } from "../Type";
import { FSKitchenCollection, mapFSKitchenCollection } from "./KitchenCollection";
import { FSKitchenFinish, mapFSKitchenFinish } from "./KitchenFinish";
import { FSKitchenRange, mapFSKitchenRange } from "./KitchenRange";
import { FSKitchenStyle, mapFSKitchenStyle } from "./KitchenStyle";

/* **************************************************** Finishing Shedule Kitchen */
export interface FSKitchen {
    id: number;
    fs_feature_id: number;
    category: string;
    location_name: string;
    location_id: number | null;
    is_default_feature: 1 | 0;
    data_kitchen: FSKitchenData[];
}

export const mapFSKitchen = (data: any): FSKitchen => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSKitchen = {
        id: data.id,
        fs_feature_id: data.fs_feature_id,
        category: data.category,
        location_name: data.location_name,
        location_id: data.location_id || null,
        is_default_feature: data.is_default_feature,
        data_kitchen: Array.isArray(data.data_kitchen) ? mapFSKitchenDatas(data.data_kitchen) : [],
    };

    return res;
};

export const mapFSKitchens = (data: any[]): FSKitchen[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSKitchen);
};

// Kitchen data
export interface FSKitchenData {
    id: number;
    fs_data_id: number;
    category: 'Type' | 'Base Units' | 'Wall Units' | 'Worktop' | 'Door' | 'Handle' | 'Appliance' | null;
    manufacture_id: number | null;
    brand_id: number | null;
    color_id: number | null;
    type_id: number | null;
    style_id: number | null;
    collection_id: number | null;
    range_id: number | null;
    finish_id: number | null;
    appliance_id: number | null;
    name: string | null;
    link: string | null;
    size_depth: number | null;
    size_thickness: number | null;
    number: number | null;
    image_path: string | null;
    file_list: FSFileList[];
    order_status: 'Pending' | 'Ordered' | 'Instore' | 'Onsite';
    order_date_data: string | null;
    order_date: string | null;
    order_data: FSDataOrder | null;
    type: FSType | null;
    kitchen_style: FSKitchenStyle | null;
    brand: FSBrand | null;
    color: FSColor | null;
    collection: FSKitchenCollection | null;
    range: FSKitchenRange | null;
    finish: FSKitchenFinish | null;
    appliance: FSAppliance | null;
    manufacture: FsManufacturer | null;
}

export const mapFSKitchenData = (data: any): FSKitchenData => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSKitchenData = {
        id: data.id,
        fs_data_id: data.fs_data_id,
        category: data.category || null,
        brand_id: data.brand_id || null,
        manufacture_id: data.manufacture_id || null,
        color_id: data.color_id || null,
        type_id: data.type_id || null,
        style_id: data.style_id || null,
        collection_id: data.collection_id || null,
        range_id: data.range_id || null,
        finish_id: data.finish_id || null,
        appliance_id: data.appliance_id || null,
        name: data.name,
        link: data.link || null,
        size_depth: data.size_depth || null,
        size_thickness: data.size_thickness || null,
        number: data.number || null,
        image_path: data.image_path || null,
        file_list: Array.isArray(data.file_list) ? mapFSFileLists(data.file_list) : [],
        order_status: data.order_status,
        order_date_data: data.order_date_data || null,
        order_date: data.order_date || null,
        order_data: data.order_data ? mapFSDataOrder(data.order_data) : null,
        type: data.type ? mapFSType(data.type) : null,
        kitchen_style: data.kitchen_style ? mapFSKitchenStyle(data.kitchen_style) : null,
        brand: data.brand ? mapFSBrand(data.brand) : null,
        color: data.color ? mapFSColor(data.color) : null,
        collection: data.collection ? mapFSKitchenCollection(data.collection) : null,
        range: data.range ? mapFSKitchenRange(data.range) : null,
        finish: data.finish ? mapFSKitchenFinish(data.finish) : null,
        appliance: data.appliance ? mapFSAppliance(data.appliance) : null,
        manufacture: data.manufacture ? mapFsManufacturer(data.manufacture) : null,
    };

    return res;
};

export const mapFSKitchenDatas = (data: any[]): FSKitchenData[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSKitchenData);
};